module.exports = __webpack_public_path__ + "static/media/tools-toolmode-large.9887b31b.svg";